import { environment } from 'src/environments/environment';

export const USERS_API_PREFIX = '/api/Users';

export const USERS_API = {
  LOGIN: `${USERS_API_PREFIX}/login`,
  REGISTER: `${USERS_API_PREFIX}/register`,
  REFRESH: `${USERS_API_PREFIX}/refresh`,
  MANAGE_INFO: `${USERS_API_PREFIX}/manage/info`,
  MANAGE_INFO_V2: `${USERS_API_PREFIX}/manage/info-v2`,
  USERS_LIST: `${USERS_API_PREFIX}/users`,
} as const;

export function usersApiUrl(path: (typeof USERS_API)[keyof typeof USERS_API]): string {
  return `${environment.usersApiUrl}${path}`;
}

export function isUsersRefreshRequest(url: string): boolean {
  return url.includes(USERS_API.REFRESH);
}

export function isUsersLoginRequest(url: string): boolean {
  return url.includes(USERS_API.LOGIN);
}
